define(['http', 'endpoints'], function(http, endpoints) {
    return function(originalCallback, options) {
        return function(result) {
            http.get({
                url: '{protocol}://' + endpoints.origin + result,
                callbackParam: 'callback',
                fail: options.fail,
                callback: originalCallback
            });
        };
    };
});



// WEBPACK FOOTER //
// ./rest/request/asyncRedirectModeCallbackFactory.js